import { OrderStatus } from '@blisspointmedia/bpm-types/dist/LinearBuying';

/**
 * Statuses that mean an order or instruction has been withdrawn. A row in one of these is history:
 * it delivers nothing and covers nothing, so callers filter it out rather than treating it as
 * active.
 *
 * Shared across linear and streaming — both read the same `OrderStatus` and had their own copy.
 */
export const CANCELED_ORDER_STATUSES: ReadonlySet<number> = new Set([
  OrderStatus.SENT_CANCELLATION,
  OrderStatus.CONFIRMED_CANCELLATION,
  OrderStatus.CANCELED
]);
